module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1524-f64fbdd9bb8beb840ab448eb866c76df.png";